<div class="container">
  <div class="container__header">
    <div class="container__header__title">{{ title }} Options</div>
    <div class="container__header__actions">
      <button mat-icon-button (click)="cancel()">
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>
  </div>
  <mat-progress-bar mode="indeterminate" [class.visibility-hidden]="!ui.isLoading"></mat-progress-bar>
  <div class="container__body">
    <ng-container [ngSwitch]="mode === 'lock' || customizationModes.includes(this.mode)">
      <ng-container *ngSwitchCase="true">
        <ng-container *ngIf="init$ | async; else initLoad">
          <ng-container *ngIf="users | sortBy: 'asc' : 'full_name' as items">
            <ng-container
              *ngTemplateOutlet="
                itemListTemplate;
                context: {
                  $implicit: items,
                  title: 'Users',
                  displayProp: 'full_name',
                  selectionControl: usersSelection,
                }
              "
            ></ng-container>
          </ng-container>
          <ng-container *ngIf="roles | sortBy: 'asc' : 'full_name' as items">
            <ng-container
              *ngTemplateOutlet="
                itemListTemplate;
                context: { $implicit: items, title: 'Roles', displayProp: 'name', selectionControl: rolesSelection }
              "
            ></ng-container>
          </ng-container>
        </ng-container>
        <ng-template #initLoad>
          <mat-spinner></mat-spinner>
        </ng-template>
      </ng-container>
      <ng-container *ngSwitchDefault> </ng-container>
    </ng-container>
  </div>
  <div class="container__actions">
    <button mat-flat-button (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="ui.isLoading" (click)="save()">Save</button>
  </div>
</div>

<ng-template
  #itemListTemplate
  let-items
  let-title="title"
  let-displayProp="displayProp"
  let-selectionControl="selectionControl"
>
  <div class="container__body__item-list">
    <p class="container__body__item-list__title">Lock for {{ title }}</p>
    <div class="container__body__item-list__item" *ngFor="let item of items" (click)="selectionControl.toggle(item.id)">
      <p>{{ item[displayProp] }}</p>
      <button mat-icon-button>
        <mat-icon>{{ selectionControl.isSelected(item.id) ? 'lock' : 'lock_open' }}</mat-icon>
      </button>
    </div>
  </div>
</ng-template>
